import { useEffect, useState } from 'react'
import {
    useAppDispatch,
    useAppSelector,
} from 'app/hooks';
import {
    getGroupData,
    getSubjectData,
    getChaptersData,
    getTopicsData,
    getCategoryData,
    getAvailableInBooksData,
    getSearchedQuestions,
    setSelectedFilters,
    selectQuestionFilter,
} from 'features/filters/filterSlice';
import { MultiSelect } from "react-multi-select-component";
import { toast } from 'react-toastify';

import SelectOption from './SelectOption'
import Loader from 'components/elements/Loader/Loader';
import {
    selectDashboard,
  } from 'features/dashboard/dashboardSlice';

const QuestionFilter = (props: any) => {
    const dispatch = useAppDispatch();
    const { data: dashboardData } = useAppSelector(selectDashboard);
    const {
        groupData,
        subjectData,
        chapterData,
        topicData,
        categoryData,
        availableBooksData,
        pending,
        error,
        selectedFilters
    }: any = useAppSelector(selectQuestionFilter);
    const [ownOption, setOwnOption]: any = useState([
        { "label": "Doubt", "value": "Doubt" },
        { "label": "Done", "value": "Done" },
        { "label": "Undone", "value": "Undone" },
        { "label": "LDR", "value": "LDR" },
        { "label": "TEST", "value": "TEST" }
    ])
    const [selectedSubject, setSelectedSubject]:any = useState(null);
    useEffect(() => {
        getGroups();
    }, [])

    const getGroups = () => {
        dispatch(getGroupData());
    }
    const getSubjects = (group_id: any) => {
        let filter = { ...selectedFilters }
        filter.group_id = (group_id === "Select Group") ? null : group_id;
        filter.subject_id = null;
        filter.chapter_id = null;
        filter.topic_id = null;
        filter.category_id = null;
        filter.available_in = [];
        filter.own_data = [];
        filter.doubt = false;
        filter.done = false;
        filter.lmr = false;

        dispatch(setSelectedFilters(filter))
        dispatch(getSubjectData({ group_id: group_id }));
    }
    const setFastrackOption = (e:any) => {
        let filter = { ...selectedFilters }
        filter.is_fastrack_active = e?.target?.value === 'all' ? false : true;        
        dispatch(setSelectedFilters(filter))
    }
    const getChapters = (subject_id: any) => {
        if(subject_id && subject_id !== ""){
            let subject = subjectData.find((sub:any) => sub.subject_id === subject_id);
            if(subject){
                setSelectedSubject(subject)
            }else{
                setSelectedSubject(null)
            }
        }
        let filter = { ...selectedFilters }
        filter.subject_id = (subject_id === 'Select Subject') ? null : subject_id;
        filter.chapter_id = null;
        filter.topic_id = null;
        filter.category_id = null;
        filter.available_in = [];
        filter.own_data = [];
        filter.doubt = false;
        filter.done = false;
        filter.lmr = false;

        dispatch(setSelectedFilters(filter))
        dispatch(getChaptersData({ subject_id: subject_id }));
        dispatch(getCategoryData({}));
        dispatch(getAvailableInBooksData({ subject_id: subject_id }));
    }
    const getTopic = (chapter_id: any) => {
        let filter = { ...selectedFilters }
        filter.chapter_id = (chapter_id === 'Select Chapter') ? null : chapter_id;
        filter.topic_id = null;

        dispatch(setSelectedFilters(filter))
        dispatch(getTopicsData({ chapter_id: chapter_id }));
    }
    const getCategory = (topic_id: any) => {
        let filter = { ...selectedFilters }
        filter.topic_id = (topic_id === "Select Topic") ? null : topic_id;
        dispatch(setSelectedFilters(filter))
        dispatch(getCategoryData({ topic_id: topic_id }));
    }
    const getAvailableInBooks = (category_id: any) => {
        let filter = { ...selectedFilters }
        filter.category_id = (category_id === "Select Importance Category") ? null : category_id;
        dispatch(setSelectedFilters(filter))
        dispatch(getAvailableInBooksData({ subject_id: selectedFilters.subject_id }));
    }

    const changeAvailableInBooks = (selected: any) => {
        let filter = { ...selectedFilters }
        filter.available_in = selected;
        dispatch(setSelectedFilters(filter))
    }

    const changeOwnOption = (selected: any, id: any) => {
        if (selected.length > 0) {
            let check = selected[selected.length - 1];
            if (check) {
                if (check.value === 'Done') {
                    let index = selected.findIndex((item: any) => item.value === 'Undone');
                    if (index > -1) {
                        selected.splice(index, 1);
                    }
                } else if (check.value === 'Undone') {
                    let index = selected.findIndex((item: any) => item.value === 'Done');
                    if (index > -1) {
                        selected.splice(index, 1);
                    }
                }
            }

        }
        let filter = { ...selectedFilters }
        filter.own_data = selected;
        dispatch(setSelectedFilters(filter))
    }

    const toggleFilters = () => {


        var element = document.getElementById("question-filter");
        if (element) element.classList.add("hide");

        var element2 = document.getElementById("sidebar");
        if (element2) element2.classList.add("active");

        var questionElement = document.getElementById("question-menu");
        var sidebarEement = document.getElementById("sidebar-menu");
        if (questionElement) {
            questionElement.classList.remove("fa-xmark");
            questionElement.classList.add("fa-filter");
        }
        if (sidebarEement) {
            sidebarEement.classList.remove("fa-xmark");
            sidebarEement.classList.add("fa-bars");
        }
    }
    const viewQuestions = () => {
        if (!selectedFilters.group_id) {
            toast.error('Please select group')
            return false;
        } else if (!selectedFilters.subject_id) {
            toast.error('Please select subject')
            return false;
        }
        toggleFilters();

        let bookIds = [];
        let bookIdstr = "";
        if (selectedFilters.available_in.length > 0) {
            bookIds = selectedFilters.available_in.map((item: any) => item.value)
            bookIdstr = bookIds.join(',')
        }
        let params: any = {
            group_id: selectedFilters.group_id,
            subject_id: selectedFilters.subject_id,
            chapter_id: selectedFilters.chapter_id,
            topic_id: selectedFilters.topic_id,
            category_id: selectedFilters.category_id,
            book_id: bookIdstr,
            doubt: 'n',
            imp: '',
            lmr: 'n',
            test: 'n',
            notdone: 'n',
            is_fastrack_active: selectedFilters.is_fastrack_active ? '1' : '0',
        }
        if (selectedFilters.own_data && selectedFilters.own_data.length > 0) {
            selectedFilters.own_data.map((item: any) => {
                if (item.value === 'Doubt') {
                    params.doubt = 'y';
                } else if (item.value === 'LDR') {
                    params.lmr = 'y';
                } else if (item.value === 'Undone') {
                    params.imp = 'n';
                } else if (item.value === 'TEST') {
                    params.test = 'y';
                } else if (item.value === 'Done') {
                    params.imp = 'y';
                }
            })
        }
        Object.keys(params).forEach((k) => params[k] == null && delete params[k]);

        dispatch(getSearchedQuestions(params));
    }

    return (
        <div id="question-filter" className="question-filter col-md-3 bg-blue right-border">
            {pending && <Loader />}
            <div className="row">

                <div className="d-flex flex-column flex-shrink-0 text-white sidebar col-md-12 text-start ">
                    <div className="row">
                        <div className="col-md-12">
                            <span className="fs-5">Question Filter</span>
                            <hr className="text-white" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 ">
                            <div className="input-group mb-3">
                                <SelectOption
                                    placeholder="Select Group"
                                    selected={selectedFilters.group_id}
                                    data={groupData}
                                    value={'group_id'}
                                    lable={'group_name'}
                                    onOptionChange={getSubjects}
                                />
                            </div>
                            
                            <div className="input-group mb-3">
                                <SelectOption
                                    placeholder="Select Subject"
                                    selected={selectedFilters.subject_id}
                                    data={subjectData}
                                    value={'subject_id'}
                                    lable={'subject_name'}
                                    onOptionChange={getChapters}
                                />
                            </div>

                            {(dashboardData?.is_fastrack_active === '1' && selectedSubject?.is_fastrack_active === "1" && selectedSubject?.payment_status !== "Free") && <div className="input-group mb-3">
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="all" checked={selectedFilters.is_fastrack_active ? false : true} onChange={setFastrackOption}/>
                                    <label className="form-check-label" htmlFor="inlineRadio1">All Questions</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="fasttrack" checked={selectedFilters.is_fastrack_active ? true : false} onChange={setFastrackOption}/>
                                    <label className="form-check-label" htmlFor="inlineRadio2">Fast Track Qs</label>
                                </div>
                            </div>}
                            
                            <div className="input-group mb-3">
                                <SelectOption
                                    placeholder="Select Chapter"
                                    selected={selectedFilters.chapter_id}
                                    data={chapterData}
                                    value={'chapter_id'}
                                    lable={'chapter_name'}
                                    onOptionChange={getTopic}
                                />
                            </div>

                            {!selectedFilters.is_fastrack_active && <div className="input-group mb-3">
                                <SelectOption
                                    placeholder="Select Topic"
                                    selected={selectedFilters.topic_id}
                                    data={topicData}
                                    value={'topic_id'}
                                    lable={'topic_name'}
                                    onOptionChange={getCategory}
                                />
                            </div>}

                            {!selectedFilters.is_fastrack_active && <div className="input-group mb-3">
                                <SelectOption
                                    placeholder="Select Importance Category"
                                    selected={selectedFilters.category_id}
                                    data={categoryData}
                                    value={'category_id'}
                                    lable={'category_name'}
                                    onOptionChange={getAvailableInBooks}
                                />
                            </div>}

                            {!selectedFilters.is_fastrack_active && <div className="input-group mb-3">
                                <MultiSelect
                                    overrideStrings={{ "selectSomeItems": "Select Multiple ICAI Materials" }}
                                    options={availableBooksData}
                                    value={selectedFilters.available_in}
                                    onChange={changeAvailableInBooks}
                                    labelledBy="Select"
                                    className="form-control z-10 text-start p-0"
                                />
                            </div>}

                            <div className="input-group mb-3">
                                <MultiSelect
                                    hasSelectAll={false}
                                    overrideStrings={{ "selectSomeItems": "Select Your Own" }}
                                    options={ownOption}
                                    value={selectedFilters.own_data}
                                    onChange={changeOwnOption}
                                    labelledBy="Select"
                                    className="form-control text-start p-0"
                                />
                            </div>

                            <div className="input-group mb-3 d-flex justify-content-center">
                                <button type="button" className="btn btn-primary z-0" onClick={viewQuestions}>View Questions</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default QuestionFilter;
